/** The user ids of the people named with @ in the rich composer's HTML, each once, in order (the ticket composer's notes and team chat
 *  read them here: the server's cleaner strips the mention nodes from a note, and a chat message is sent as plain text). */
export function mentionIds(html: string): string[] {
  const ids: string[] = [];
  for (const m of html.matchAll(/<span[^>]*\bdata-type="mention"[^>]*\bdata-id="([^"]+)"[^>]*>/g)) { const id = m[1]!.replace(/&quot;/g, '"').replace(/&amp;/g, "&"); if (!ids.includes(id)) ids.push(id); }
  return ids;
}
